var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgTenantIllustration = function SvgTenantIllustration(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 120,
    viewBox: "0 0 155 120",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tenant-illustration_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F5C3BD",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M47.448 23.918H151.94v49.306c0 24.689-20.043 44.732-44.732 44.732H2.717V68.649c0-24.688 20.042-44.731 44.731-44.731Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2D3F",
    d: "M95.56 85.198c1.177 3.83 4.864 17.906 3.817 32.201-1.047 14.29 1.738 17.696 1.738 21.965 0 4.27 8.4 20.776 9.431 28.288 1.031 7.512 1.579 26.453 1.579 26.453s-4.75 10.536-13.913 4.281c-1.37-7.512-6.674-42.368-11.831-54.304-5.157-11.936-23.574-51.715-23.574-51.715L72.09 80.53l23.473 4.671-.004-.004Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2D3F",
    d: "M80.491 126.398s-1.093 3.544-3.682 18.71c.192 10.39 8.467 27.5.59 50.836-8.596 5.479-14.587 0-14.587 0s-6.896-24.237-8.597-38.38c-1.701-14.144 5.584-52.914 7.092-61.314 1.513-8.4 15.35 8.488 15.35 8.488l3.83 21.66h.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBD7D0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "m65.61 107.097 5.743 3.8 9.138 19.992",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF5F58",
    d: "M93.508 33.688c-5.676-3.65-6.53-4.005-6.53-4.005l-12.213.238s-16.189 6.012-19.477 11.794c-3.293 5.777-6.624 18.019-6.624 18.019s6 2.51 11.559 2.086c0 4.655-2.72 34.878-2.72 34.878s31.23 5.463 39.65-5.35c-.69-3.67-.21-14.148-.77-23.382-1.023-16.745-2.87-34.278-2.87-34.278h-.005Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFAA80",
    d: "M86.503 17.981c-.691 2.84-.712 9.678.692 12.12-1.496 4.442-6.775 6.704-9.64 6.44-2.866-.264-1.836-6.213-1.836-6.213l.905-4.981L86.5 17.98h.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DBAC95",
    d: "M84.161 22.498s-1.09 5.681-8.044 5.681l.515-2.832 7.533-2.849h-.004Z",
    opacity: 0.47,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFAA80",
    d: "M87.923 9.1c-.83-2.187-10.629-3.242-11.835-2.036-1.207 1.207-1.311 3.57-1.734 6.938-.541 4.298-1.618 10.847.75 11.827 2.367.98 9.363.297 11.4-7.847 2.035-8.14 1.42-8.882 1.42-8.882Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CC9061",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M81.732 20.068c-.432 1.152-1.647 1.546-2.59 1.546"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB8667",
    d: "M82.296 16.662a.77.77 0 1 0 0-1.542.77.77 0 0 0 0 1.542Zm-5.533-.775a.77.77 0 1 0 0-1.541.77.77 0 0 0 0 1.541Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CC9061",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M79.146 15.473c-.83 1.621-2.489 2.589-1.609 3.469.88.88 1.42.942 1.42.942"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#94645A",
    d: "M87.2 16.624c-2.929-.854-4.513-6.695-4.513-6.695s-3.552 1.697-6.053.189c-1.534.637-4.358-.075-4.358-1.998-3.644-1.207-1.32-7.09 2.816-4.864 2.702-1.848 5.978-1.245 7.373 1.81 1.886-1.886 6.548-.076 6.548 3.016 3.08 1.273.956 7.06-.138 8.542-1.194 1.194-1.671 0-1.671 0H87.2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFAA80",
    d: "M86.898 16.365c1.789-1.79 3.963.892-.645 3.067-1.37-1.37.645-3.067.645-3.067Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#BA804F",
    d: "m76.801 74.615-40.364-8.278L30.4 95.78l40.364 8.278L76.8 74.615Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#CB8E62",
    d: "m77.98 52.05-33.4-6.85-4.489 21.887 33.4 6.85 4.488-21.887Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#DDA87F",
    d: "m57.097 70.576 4.504-21.953L44.575 45.2l-4.487 21.89 17.01 3.486Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3BCA7",
    d: "m55.717 47.486-4.867-.999-1.994 9.719 4.868.998 1.993-9.718Z",
    opacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#CB8E62",
    d: "m47.318 68.566-10.88-2.23L30.4 95.782l10.876 2.229 6.042-29.444Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C56A67",
    d: "M95.116 74.096S92.184 87.712 84.19 92.32c-6.645 3.83-11.852 3.239-11.852 3.239l2.388-11.957 20.386-9.51.004.004Z",
    opacity: 0.16,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFAA80",
    d: "M105.306 57.447c-6.356 12.66-10.86 21.777-18.928 27.454-8.07 5.677-26.327 9.778-28.874 11.798-2.548 2.015-4.588 4.654-9.134 4.357-4.55-.294-7.516.13-10.88-3.825.88 0 3.147.574 4.558.13.507-.16.93-.558 1.756-1.425 2.195-2.313 2.497-4.512 2.497-4.512s-4.638.297-5.744-.256c-1.102-.553-1.588-3.1.863-2.94 2.45.159 9.276-3.034 13.624-.847 6.452-1.076 7.763-1.948 13.428-6.364 6.125-4.776 13.314-7.792 13.314-7.792l9.745-21.048 13.779 5.27h-.004Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF5F58",
    d: "M93.507 33.688c4.282 3.23 11.702 6.373 13.122 12.984 1.341 6.242-2.526 15.032-4.37 19.33-2.358 2.359-13.871-1.336-15.672-5.094-4.073-11.228 6.92-27.22 6.92-27.22Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CC9061",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M41.34 100.155s3.724.725 5.077-2.304m-2.212 3.456s4.156-.251 5.078-2.304m-2.535 2.924s4.156-.251 5.078-2.304"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tenant-illustration_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.873 0h153.252v120H.873z"
  })))));
};

export { SvgTenantIllustration as ReactComponent };
export default "/_next/static/media/tenant-illustration.be69c9fe.svg";